var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgD2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 56,
    viewBox: "0 0 40 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5537 13.772C21.5537 15.722 20.9297 17.152 18.7457 19.466C16.6137 21.702 15.8857 23.236 15.8857 25.264V27.5H24.1537V24.9H18.7457C18.7197 24.77 18.7197 24.64 18.7197 24.51C18.7197 23.548 19.1877 22.69 20.8777 20.87C23.5297 18.036 24.4137 16.086 24.4137 13.668C24.4137 10.756 22.9577 9.09204 20.1497 9.09204C17.3417 9.09204 15.8857 10.756 15.8857 13.668V15.436H18.5897V13.486C18.5897 12.186 19.1617 11.692 20.0717 11.692C20.9817 11.692 21.5537 12.134 21.5537 13.772Z",
    fill: "#DC3059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0566 33.1666L25.3333 40.4622L19.9433 47.8333L14.6666 40.5378L20.0566 33.1666Z",
    fill: "#DC3059"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD2);
export default __webpack_public_path__ + "static/media/D2.dc2da60a2c3797639ffd075e3c34586b.svg";
export { ForwardRef as ReactComponent };